export const TRACK_EVENT = 'candidateExperience/views/analytics/TRACK_EVENT'

export const trackEvent = (name, data) => ({
  type: TRACK_EVENT,
  meta: { name, data },
})
